import React from 'react';
import { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import QuizView from '../components/QuizView';
import './QuizPage.css';
import { submitQuizAttempt } from '../api/studentApi';
import ResultsView from '../components/ResultsView';
import QuizReview from '../components/QuizReview';
import LoadingSpinner from '../components/LoadingSpinner';
import { useUser } from '../context/UserContext';
import QuizPageHeader from '../components/QuizPageHeader';

const QuizPage = () => {
    const { topicId } = useParams();
    const location = useLocation();
    const [results, setResults] = useState(null);
    const [seconds, setSeconds] = useState(0);
    const [isReviewMode, setReviewMode] = useState(false);
    const [reviewData, setReviewData] = useState(null);
    const [quizSubmitting, setQuizSubmitting] = useState(false);

    const { triggerUserUpdate } = useUser();

    const displayTitle = location.state?.title || "Quiz";
    const subjectName = location.state?.subject || '';
    const [isQuizFinished, setIsQuizFinished] = useState(false);

    useEffect(() => {
        if (isQuizFinished || results) return; // Stop timer when quiz is finished

        const interval = setInterval(() => {
            setSeconds(prev => prev + 1);
        }, 1000);

        return () => clearInterval(interval);
    }, [isQuizFinished, results]);

    const handleQuizFinished = async (questions, responses, totalTime) => {
        setIsQuizFinished(true);
        try {
            setQuizSubmitting(true);
            const payload = {// You will replace this with your actual logged-in user ID later
                topicId: topicId,
                responses: responses,
                totalTimeSeconds: totalTime
            };
            const response = await submitQuizAttempt(payload);
            setResults(response.data); // Stores { score, total, message }
            setReviewData(response.data.reviewData); // Store review data for later use
            await triggerUserUpdate();
        } catch (err) {
            console.error("Submission failed", err);
            alert("Failed to save results. Please try again.");
        } finally {
            setQuizSubmitting(false);
        }
    };

    return (
        <div className="quiz-page-wrapper">
            <QuizPageHeader
                subjectName={subjectName}
                displayTitle={displayTitle}
                seconds={seconds}
            />
            <main className="quiz-main-content">
                {/* 1. Review Mode */}
                {isReviewMode ? (
                    <QuizReview
                        questions={reviewData?.questions}
                        userAnswers={reviewData?.userAnswers}
                        onClickRestart={() => {
                            setSeconds(0);
                            setResults(null);
                            setReviewMode(false);
                        }}
                    />
                ) : results ? (
                    /* 2. Results Mode */
                    <div className="quiz-page-container">
                        <ResultsView
                            results={results}
                            topicName={displayTitle}
                            onClickReview={() => setReviewMode(true)}
                        />
                    </div>
                ) : (
                    /* 3. Active Quiz with Loading Overlay */
                    <div className="quiz-page-container quiz-active-wrapper">
                        {quizSubmitting && (
                            <div className="quiz-spinner-overlay" aria-live="polite" aria-busy="true">
                                <LoadingSpinner message="Submitting your quiz..." />
                            </div>
                        )}
                        <QuizView
                            topicId={topicId}
                            onComplete={handleQuizFinished}
                            topicName={displayTitle}
                        />
                    </div>
                )}
            </main>
        </div>
    );
};

export default QuizPage;